// 断点

import React, { createContext, useContext, useMemo } from 'react'

interface BreakPointContextValue {
    onSyncOne?: (name: string | string[], previewId: string) => void
    onSyncAll?: (previewId: string) => void
}

const BreakPointContext = createContext<BreakPointContextValue>({})

interface BreakPointProviderProps extends BreakPointContextValue {
    children: React.ReactNode
}

export const BreakPointProvider: React.FC<BreakPointProviderProps> = ({ children, onSyncOne, onSyncAll }) => {
    const ctxValue = useMemo(() => ({ onSyncOne, onSyncAll }), [onSyncAll, onSyncOne])
    return <BreakPointContext.Provider value={ctxValue}>{children}</BreakPointContext.Provider>
}

export const useBreakPointContext = () => useContext(BreakPointContext)

BreakPointContext.displayName = 'BreakPointContext'
